<template>
  <div v-if="!this.$route.params.date">
      <transition name="slide-x-transition" mode="out-in">
        <keep-alive>
      <list/>
        </keep-alive>
      </transition>
  </div>
  <div v-else>
      <transition name="slide-x-transition" mode="out-in">
      <detail/>
      </transition>
  </div>
</template>

<script>
import list from "./list.vue";
import detail from "./detail.vue";
export default {
  name: "Diary",
  components: {
    list,
    detail
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  }
};
</script>

<style scoped>
</style>